<template>
    <b-card-group>
        <b-card no-body>
            <div class="card-body">
                <div>
                    <b-form class="filter-form">
                        <b-row>
                            <b-col cols="1">
                              <b-button v-on:click="reset" size="sm" variant="secondary" class="ml-2">
                                <font-awesome-icon icon="times" />
                                {{ $t('Сброс') }}
                              </b-button>
                            </b-col>
                            <filter-input cols="2" :label="$t('Название')" v-model="form.name"
                                    v-on:onBlur="search"></filter-input>
                        </b-row>
                    </b-form>
                </div>
            </div>
        </b-card>
    </b-card-group>
</template>

<script>
  import BaseFilter from "@/models/base.filter";

  export default {
    name: "filter-form",
    extends: BaseFilter,
    props: {
      name: String
    },
    data() {
      return {
        form: {
          name: this.name
        }
      };
    }
  };
</script>
